import { TrustpilotReviewCard } from "./TrustpilotReviewCard";
import { CardFooter } from "./CardFooter";
import type { TrustpilotReviewCardProps } from "./TrustpilotReviewCard.d";

export { TrustpilotReviewCard, CardFooter, TrustpilotReviewCardProps };
